import './Home.css';
import man1 from './man1.png';
const Home = (props) => {
    const link = props.alldata[0].resume_link;
    const downloadResume = () => {
        window.open(link, '_blank');
    }
    return (
        <div className="home">
            <div className="image">
                <img src={man1} alt="sad?" />
            </div>
            <div className="content">
                <h1>Hi, I'm <span>Vishwash Soni!</span></h1>
                <br></br>
                <br></br>
                <br></br>
                <p>I'm a passionate Frontend Developer and Problem Solver who thrives on crafting user-friendly web experiences and tackling complex algorithmic challenges. With expertise in <span>HTML</span>,<span>CSS</span>,<span>JavaScript</span>,<span>React</span>, and <span>C++</span>, I build sleek, responsive, and efficient web applications.</p>
                <button className="resume-button" onClick={downloadResume}>
                    Download Resume
                </button>
            </div>
        </div>
    );
}
export default Home;